import type { ErrorDetail } from "@exploitlens/ui-contracts";

/**
 * Renders a real bundle-loading/validation failure -- a missing file, a
 * network error, a schema mismatch. Distinct from a gate `fail`/
 * `inconclusive` verdict (which is real evidence and renders in the case
 * views themselves, never here): this state means the evidence could not be
 * read at all.
 */
export function BundleErrorState({ error }: { error: ErrorDetail }) {
  return (
    <div role="alert" className="mx-auto max-w-xl px-6 py-16 text-center">
      <p className="font-editorial text-xl text-ink">The evidence bundle could not be loaded.</p>
      <p className="mt-3 text-sm text-loss">
        [{error.code}] {error.message}
      </p>
      {error.details !== undefined && (
        <pre className="mt-4 max-w-full overflow-x-auto rounded border border-rule bg-canvas-raised p-3 text-left font-evidence text-xs text-ink-muted">
          {JSON.stringify(error.details, null, 2)}
        </pre>
      )}
    </div>
  );
}
